import { Skeleton } from "antd";

export function BlogBannerSkeleton() {
  return (
    <div className="group relative max:w-[1242px] sm:min-h-[310px] h-auto bg-card rounded-[8px] mt-[30px] mobile:mt-[50px] md:mt-[20px] sm:flex flex-col sm:flex-row  overflow-hidden border border-overlay">
      {/* Left image */}
      <div
        className="flex justify-center items-center sm:w-[952px] w-full sm:h-[310px] h-[200px] overflow-hidden relative
      sm:max-w-[702px]
      md:max-w-[100vw]
      lg:max-w-[1200px]
      xl:max-w-[1400px]
      2xl:max-w-[1625px]"
      >
        <Skeleton.Image
          active
          className="!w-20 !h-20 !rounded-none"
        />
      </div>

      {/* Right panel */}
      <div className="relative sm:w-[738px] w-full sm:h-[310px] h-auto overflow-hidden">
        <div className="sm:absolute sm:inset-0 sm:p-6 p-4 flex flex-col sm:justify-between justify-start z-20">
          {/* Author */}
          <div className="flex items-center gap-3 sm:mb-0">
            <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 relative">
              <Skeleton.Avatar active size={40} shape="circle" />
            </div>
            <div className="flex flex-col w-[120px] sm:w-[66px] md:w-[120px]">
              <Skeleton.Input
                active
                size="small"
                className="block !w-full !h-[20px]"
              />
              <Skeleton.Input
                active
                size="small"
                className="block !w-full !h-[16px] mt-1"
              />
            </div>
          </div>

          {/* Title */}
          <Skeleton.Input
            active
            style={{ width: "80%", height: 28, marginTop: 20 }}
          />

          {/* Description */}
          <Skeleton
            active
            paragraph={{ rows: 3 }}
            title={false}
            style={{ marginTop: 20 }}
          />

          {/* Button */}
          <Skeleton.Input
            active
            style={{ width: 100, height: 20, marginTop: 20 }}
            size="small"
          />
        </div>
      </div>
    </div>
  );
}
